const triggers = ['click', 'hover'];
export const defaultTooltipPosition = {
    top: '-1000px',
    left: '-1000px',
    transform: 'none',
};
export const getAnimationConfig = (animation = 'scale') => {
    switch (animation) {
        case 'scale':
            return {
                from: { scale: 0, opacity: 0 },
                enter: { scale: 1, opacity: 1 },
                leave: { scale: 0, opacity: 0 },
            };
        case 'opacity':
            return {
                from: { opacity: 0, scale: 1 },
                enter: { opacity: 1, scale: 1 },
                leave: { opacity: 0, scale: 1 },
            };
        default:
            return {
                from: { scale: 0, opacity: 0 },
                enter: { scale: 1, opacity: 1 },
                leave: { scale: 0, opacity: 0 },
            };
    }
};
const getDefaultOffset = (customOffset, showArrow = true) => {
    return showArrow ? 8 + customOffset : customOffset !== null && customOffset !== void 0 ? customOffset : 0;
};
const getExtraByAnimation = (animation = 'scale') => {
    if (animation === 'scale') {
        return {
            bottom: {
                transformOrigin: 'top left',
            },
        };
    }
    return {
        bottom: {
            transformOrigin: undefined,
        },
    };
};
export const getPosition = (placement, rect, _offset, hasArrow = true, animation) => {
    const offset = getDefaultOffset(_offset, hasArrow);
    const extra = getExtraByAnimation(animation);
    const positions = {
        top: {
            top: `${rect.top - offset}px`,
            left: `${rect.left + rect.width / 2}px`,
            transform: 'translate(-50%, -100%)',
        },
        topStart: {
            top: `${rect.top - offset}px`,
            left: `${rect.left}px`,
            transform: 'translate(0, -100%)',
        },
        topEnd: {
            top: `${rect.top - offset}px`,
            left: `${rect.left + rect.width}px`,
            transform: 'translate(-100%, -100%)',
        },
        bottom: Object.assign({ top: `${rect.bottom + offset}px`, left: `${rect.left + rect.width / 2}px`, transform: 'translate(-50%, 0)' }, extra.bottom),
        bottomStart: {
            top: `${rect.bottom + offset}px`,
            left: `${rect.left}px`,
            transform: 'translate(0, 0)',
        },
        bottomEnd: {
            top: `${rect.bottom + offset}px`,
            left: `${rect.left + rect.width}px`,
            transform: 'translate(-100%, 0)',
        },
        left: {
            top: `${rect.top + rect.height / 2}px`,
            left: `${rect.left - offset}px`,
            transform: 'translate(-100%, -50%)',
        },
        leftStart: {
            top: `${rect.top}px`,
            left: `${rect.left - offset}px`,
            transform: 'translate(-100%, 0)',
        },
        leftEnd: {
            top: `${rect.top + rect.height}px`,
            left: `${rect.left - offset}px`,
            transform: 'translate(-100%, -100%)',
        },
        right: {
            top: `${rect.top + rect.height / 2}px`,
            left: `${rect.right + offset}px`,
            transform: 'translate(0, -50%)',
        },
        rightStart: {
            top: `${rect.top}px`,
            left: `${rect.right + offset}px`,
            transform: 'translate(0, 0)',
        },
        rightEnd: {
            top: `${rect.top + rect.height}px`,
            left: `${rect.right + offset}px`,
            transform: 'translate(0, -100%)',
        },
    };
    return positions[placement] || positions.top;
};
const defaultRect = {
    top: -1000,
    left: -1000,
    right: -1000,
    bottom: -1000,
    width: 0,
    height: 0,
};
export const getRect = (ref, getPopupContainer) => {
    var _a;
    if (!ref || !ref.current)
        return defaultRect;
    const rect = ref.current.getBoundingClientRect();
    // FIXME: bug: getPopupContainer not defined will return error position rect
    const container = (_a = ((getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    return Object.assign(Object.assign({}, rect), { width: rect.width || rect.right - rect.left, height: rect.height || rect.bottom - rect.top, top: rect.top + document.documentElement.scrollTop - container.top, bottom: rect.bottom + document.documentElement.scrollTop - container.top, left: rect.left + document.documentElement.scrollLeft - container.left, right: rect.right + document.documentElement.scrollLeft - container.left });
};
